import { render, staticRenderFns } from "./ShieldIcon.vue?vue&type=template&id=4acdd760&scoped=true"
import script from "./ShieldIcon.vue?vue&type=script&lang=js"
export * from "./ShieldIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../web-components/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acdd760",
  null
  
)

export default component.exports